<template>
  <div class="xwzxmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="xwzxcont">

      <el-row>
        <el-col style="margin-right:20px" :span="5">

          <div class="zcsj">
            Exhibit Hours
          </div>
         <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 2, 2026, 9:00am-5:00pm
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 3, 2026,  9:00am-5:00pm
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 4, 2026,  9:00am-4:00pm
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              (Last admission 1 hour before closing)
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div style="margin:50px 20px">
            <h2>Connect with us to delve into the possibilities awaiting you at CIEPEC2026 and discover how exhibiting can propel your business to new heights.
            </h2>
            <h2> E-mail：</h2>
            <h3>intl@caepi.org.cn</h3>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import newsDetail from '../newsDetail/index.vue'
export default {
  name: 'Xwzx',
  components: {
    newsDetail
  },
  data () {
    return {
      menuName: '中国国际环保展览会',
      pageNum: '1',
      content: '1212121',
      type: '',
      currentPage: 1,
      pagesize: 1,
      // 第一个菜单
      cd1: {},
      cd2: {}

    }
  },
  created () {
    this.cd1 = {
      news: [
        {
          images: 'https://www.ciepec-online.com/u/cms/www/xwy-images/1.jpg',
          title: '关于邀请参加第二十二届中国国际环保展览会和2024生态环保产业创新发展大会的函',
          content: 'https://www.ciepec-online.com/u/cms/www/xwy-images/2.png',
          time: '2023-09-06',
          type: 'image',
          abstract: '关于邀请参加第二十二届中国国际环保展览会和2024生态环保产业创新发展大会的函'
        },
        {
          images: 'https://www.ciepec-online.com/u/cms/www/xwy-images/1.jpg',
          title: '生态环保产业迎来发展大时代',
          content: '生态环保产业作为生态环境治理的有效供给，是美丽中国建设目标实现的关键支撑，是绿色生产力的重要载体，是经济发展的新增长点，面临难得的发展机遇。在近日举办的第二十二届中国国际环保展览会暨第六届生态环保产业创新发展大会上，生态环境部副部长赵英民表示，生态环保产业已经进入绿色创新开放的高质量发展阶段，全面推进美丽中国建设，加快构建人与自然和谐共生的现代化，生态环保产业必将迎来发展的大时代。产业创新硕果累累走进展会，可以看到一批市场急需的高新技术装备。在生态环境部卫星环境应用中心的展台上，一只机器狗“趴”在地上，这台搭载着摄像头的机器狗在内蒙古草原植物多样性调查时能够替科研人员“跑腿”，快速实现对草原植物的观测、拍照和图像回传，提高植物监测效率。瓦尔登技术集团携旗下中晶环境、赛宝新能源、城康生态3家板块公司亮相，其展示的一款名叫元甲的设备很受关注。赛宝绿创能源首席运营官林琳介绍，元甲是一个移动的储能加充电设备，可以覆盖工商业区、园区、居民区和高速公路服务区，为新能源车主提供移动上门充电服务。结合我国当前生态环境保护重点，本次展览会筛选了一批市场急需的高新技术装备，在水、气、固、监测等主题馆的基础上，增设了油烟管控服务专区、除尘净化展示专区、机动车船污染治理展示专区、生态环境科技创新成果展区、新能源电池退役处理与利用专区、噪声与振动控制展示专区等。展会上还有一个特别设立的展区，即“中国生态环保产业40年成就展出”，展示了生态环保产业的发展成绩。如突破了一大批重大前沿与关键核心技术，火电厂超低排放、大型垃圾焚烧等技术装备达到国际领先水平，环境监测仪器设备基本实现国产化、自动化、成套化、智能化、立体化。40年来，伴随着我国生态环保事业的发展，生态环保产业体系不断完善，产业规模不断壮大。天眼查专业版数据显示，截至目前，我国拥有与生态环保相关的企业220.9万余家。环保科技成果在国家科学技术进步奖中表现突出。工业烟气多污染物协同深度治理技术、制浆造纸清洁生产与水污染全过程控制技术等荣获国家科技进步奖一等奖。2019年至2023年间评选出的173项获奖项目，年度产值高达300亿元，涉及专利1500多件。可以说，生态环保产业发挥了深入打好污染防治攻坚战的主力军、实现“双碳”战略目标的生力军作用，为美丽中国建设和经济社会高质量发展作出重要贡献。减污降碳协同增效今年1月，《中共中央 国务院关于全面推进美丽中国建设的意见》印发，明确提出了2027年和2035年目标。《意见》强调，“十四五”时期深入攻坚，实现生态环境持续改善；“十五五”时期巩固拓展，实现生态环境全面改善；“十六五”时期整体提升，实现生态环境根本好转。中国环境保护产业协会会长郭承站表示，“十四五”规划目标任务、“双碳”战略目标、美丽中国建设、产业升级、绿色转型等时代主题对应着不断增长和变化的生态环保产业新目标、新要求、新任务、新市场。在新目标的引领下，我国生态环保产业的发展重点、根本动力、有效路径正在发生前所未有的变化。生态环境部科技与财务司司长王志斌表示，产业需求端由支撑污染防治攻坚战逐步转向支撑美丽中国建设和实现“双碳”目标；产业发展的重点由单一环境要素末端治理转向跨领域、多要素、系统协调的综合治理；产业领域拓展到源头防控、清洁生产循环利用、生态修复以及与碳中和减污降碳、多污染物协同减排、应对气候变化、生物多样性保护、新污染物治理、核安全等，成为当前生态环境科技创新的重点领域。赵英民表示，我国经济社会发展已进入加速绿色化、低碳化的高质量发展阶段，减污降碳协同增效成为生态环保产业的关键新赛道。生态环保产业应顺应新形势，从传统的污染治理向绿色、低碳、循环发展全面升级。英民提出，生态环保产业应以减污降碳、扩绿增长为目标，不断拓宽产业发展领域和范围，以科技创新引领产业创新。精准识别污染问题，提供系统解决方案。用好巨大的国内市场优势，积极探索与互联网、大数据、人工智能、5G等新兴技术深度融合，形成新产业、新业态，新模式，为美丽中国建设提供强大的产业和技术支撑。环保企业勇担使命展会期间，20余家环保企业参加了由中国环境保护产业协会主办、江苏盐城环保科技城支持的新成果、新技术、新产品、新材料企业媒体发布会。会议共发布近百项新技术、新产品、新材料及案例。陕西中合态数据科技有限公司是一家国家级高新技术企业。该企业有关负责人介绍，当前，由于生态环境要素监测的复杂性，监测系统的数据有效性难以保障。其研发的“固定污染源废气现场监测智能管理系统”已应用于现场监测活动，可实现监测标准化管理、数字化研判、智能化升级、动态预警以及智慧监管的目标。生态分区管理对检测提出了更高要求，为精准检测设备企业带来利好。北京兰友科技总经理马放均介绍，公司研制的土壤采样制样存储智能化设备，解决了土壤手工监测误差大、监测周期长、质量难以控制、难以溯源等行业痛点问题，能为生态分区管理提供精准检测结果。当前，我国生态环保产业发展水平与绿色低碳发展内在要求仍存在差距。推动大规模设备更新和消费品以旧换新，发展循环经济推进清洁生产，实现源头减量、过程减排、末端治理和综合利用等，都将为环保产业带来巨大发展机遇。各类环保企业应结合自身优势，加大创新力度，错位差异化发展。生态环保企业应以科技创新引领产业创新，开创产业发展新局面。“环保产业未来出路应该是一个‘大’字，我们要做‘大环保科技、大环保产业’。将来环保产业要走出去，要走向深处，探索没有人做的领域。”中国工程院院士、中国科学院生态环境研究中心研究员曲久辉表示，环保产业和其他产业相比，还在低端运行、低端发展、低端竞争。这就反映了我国环保产业还有待提升。环境科技与环保产业发展要立足生态、走入广域、发展新质生产力。“之所以要立足生态，严格来讲，现在的环保产业是面向污染治理的，不是面向生态的。面向生态、走进生态，环保产业的发展就不仅是环境本身，也会涉及AI、材料、信息、生物等领域，包括其他通用机械等新发展方向。”曲久辉说。生态环保企业要积极响应国家有关政策，努力赢得更大发展。安永（中国）企业咨询有限公司间接税服务合伙人岳蕾表示，为了支持环保产业的发展，国家出台了一系列财税政策，旨在降低企业的生产成本，促进产品改造升级，实现低碳发展，并帮助企业适应国际化竞争环境。建议企业积极响应国家的政策引导，通过设备更新和以旧换新，提高资源利用效率，同时享受可能的税收减免。郭承站表示，环保产业企业应抢抓机遇，顺势而为，持续创新，实施产业链补链、延链、升链、建链，成为中国经济绿色崛起的“加速器”。“特别是要抓住大规模设备更新周期性的契机，推动高端化、智能化、绿色化发展，推动先进产能比重持续提升，推动环保产业焕发新的生机活力。”赵英民指出。（经济日报记者 刘 瑾）END 来源：经济日报',
          time: '2024-04-28',
          type: 'text',
          abstract: ''
        }],
      total: 2
    }
    this.cd2 = {
      news: [{
        images: 'https://www.ciepec-online.com/u/cms/www/xwy-images/3.jpg',
        title: '第二十一届中国国际环保展览会（CIPEC 2023） “新时代背景下环境技术发展” 分论坛成功举办',
        content: 'https://www.ciepec-online.com/u/cms/www/xwy-images/4.png',
        time: '2023-04-26',
        type: 'image',
        abstract: '第二十一届中国国际环保展览会（CIPEC 2023） “新时代背景下环境技术发展” 分论坛成功举办'
      },
      {
        images: 'https://www.ciepec-online.com/u/cms/www/xwy-images/3.jpg',
        title: '第二十一届中国国际环保展览会及第五届生态环保产业创新发展大会开幕',
        content: 'https://www.ciepec-online.com/u/cms/www/xwy-images/5.png',
        time: '2023-04-26',
        type: 'image',
        abstract: '第二十一届中国国际环保展览会及第五届生态环保产业创新发展大会开幕'
      }],
      total: 2
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
      this.currentPage = 1
    },
    xqdetail (item) {
      this.content = item.content
      this.type = item.type
      this.title = item.title
      this.pageNum = 'xq'
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange (size) {
      this.pagesize = size
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.xwzxmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/home/Header1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.midbgi {
  background-image: url('../../assets/home/renwu.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: 40% 100%;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.xwzxcont {
  width: 80%;
  margin: 0 auto;
}

.xwzxcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;
  /* height: 450px; 元素高度 */
  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}
.newslist {
  display: flex;
  justify-content: space-around;
  align-items: center;

  height: 250px;
}
.newstime {
}
.news {
  flex: 1;
}
.newstlt {
  width: 500px;
  font-size: 22px;
  color: #000000;
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 20px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
}
.newsdetail {
  width: 600px;
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 95px;
}
.newsimg {
  margin-top: 30px;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.fyys {
  text-align: center;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/caidaneng/xwzx.vue